<template>
  <article class="c-content--sendPoint c-scrollbar">
    <div class="c-content--app_container">
      <h2 class="c-text-center">Seleccione fecha de recojo</h2>
      <div>
        <app-calendar @getDate="getDataCalendar"></app-calendar>
      </div>
      <!-- <article class="c-grid--services__item pb-2">
        <div class="calculate-font text-center c-content--line-half">Ó</div>
      </article> -->
      <!--<div class="c-content--calculate-service">
        <h2>Calcular servicios</h2>
        <article class="c-grid--services__item">
          <div
            id="btnOpenModalCalculatorProgrammed"
            class="card c-card c-card--service-box d-flex p-1"
          >
            <div class="card-image">
              <div class="card-title color-text-black">
                <span class="card-sub-title color-text-black">calcular</span
                ><span class="card-option">Envío programado</span>
              </div>
            </div>
            <img
              src="~@/assets/img/service-calculate-2.svg"
              class="translatex"
            />
          </div>
        </article>
      </div>-->
      <!-- <div class="pt-2 pb-4">
        <div class="m-0 d-flex justify-content-center">
          <a
            id="btnOpenModalRestriction"
            class="c-button c-button--five c-button--mobile-small waves-effect restriccion"
          >
            Ver restricciones
            <img src="~@/assets/img/icon/icon-danger.svg" alt=""/>
          </a>
        </div>
      </div> -->
    </div>
  </article>
</template>

<script>
import AppCalendar from "../../General/AppCalendar.vue";

export default {
  components: {
    AppCalendar,
  },
  name: "Step1-Content",
  methods: {
    getDataCalendar(date) {
      this.$store.dispatch("PROGRAMMED_ORDER_DELIVER_DATE", date);
      this.$eventBus.$emit("setDateModal", date);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch("PROGRAMMED_PROGRESS_NAV_STEP", 1);
    });
  },
};
</script>

<style>
/* .c-content.c-content--app.c-content--mobile-spacing-top.c-content--full_height.pb-0 {
  padding-top: 7em;
} */
</style>
